var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgSlack = function SvgSlack(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_657_25707)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0804 38.3342C18.0804 41.1103 15.8127 43.3781 13.0366 43.3781C10.2605 43.3781 7.99268 41.1103 7.99268 38.3342C7.99268 35.5581 10.2605 33.2903 13.0366 33.2903H18.0804V38.3342Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6216 38.3342C20.6216 35.5581 22.8894 33.2903 25.6655 33.2903C28.4416 33.2903 30.7094 35.5581 30.7094 38.3342V50.9634C30.7094 53.7395 28.4416 56.0073 25.6655 56.0073C22.8894 56.0073 20.6216 53.7395 20.6216 50.9634V38.3342Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6655 18.0804C22.8894 18.0804 20.6216 15.8127 20.6216 13.0366C20.6216 10.2605 22.8894 7.99268 25.6655 7.99268C28.4416 7.99268 30.7094 10.2605 30.7094 13.0366V18.0804H25.6655Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6658 20.6221C28.4419 20.6221 30.7097 22.8899 30.7097 25.666C30.7097 28.442 28.4419 30.7098 25.6658 30.7098H13.0366C10.2605 30.7098 7.99268 28.442 7.99268 25.666C7.99268 22.8899 10.2605 20.6221 13.0366 20.6221H25.6658Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9194 25.666C45.9194 22.8899 48.1872 20.6221 50.9633 20.6221C53.7394 20.6221 56.0072 22.8899 56.0072 25.666C56.0072 28.442 53.7394 30.7098 50.9633 30.7098H45.9194V25.666Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3782 25.6658C43.3782 28.4419 41.1105 30.7097 38.3344 30.7097C35.5583 30.7097 33.2905 28.4419 33.2905 25.6658V13.0366C33.2905 10.2605 35.5583 7.99268 38.3344 7.99268C41.1105 7.99268 43.3782 10.2605 43.3782 13.0366V25.6658Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3344 45.9194C41.1105 45.9194 43.3782 48.1872 43.3782 50.9633C43.3782 53.7394 41.1105 56.0072 38.3344 56.0072C35.5583 56.0072 33.2905 53.7394 33.2905 50.9633V45.9194H38.3344Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3344 43.3781C35.5583 43.3781 33.2905 41.1103 33.2905 38.3342C33.2905 35.5581 35.5583 33.2903 38.3344 33.2903H50.9635C53.7396 33.2903 56.0074 35.5581 56.0074 38.3342C56.0074 41.1103 53.7396 43.3781 50.9635 43.3781H38.3344Z",
    fill: "#ECB22E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_657_25707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(8 8)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slack.24fd4e240e205f0bbf669f02cf1a37b0.svg";
export { ForwardRef as ReactComponent };